import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { CMSProvider } from './context/CMSContext';
import { Layout } from './components/layout/Layout';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import DynamicPage from './pages/DynamicPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <CMSProvider>
                    <Routes>
                        {/* Admin Routes (no layout) */}
                        <Route path="/admin/login" element={<AdminLoginPage />} />
                        <Route path="/admin/*" element={<AdminDashboard />} />
                        
                        {/* Public Routes (with layout) */}
                        <Route path="/" element={<Layout><HomePage /></Layout>} />
                        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
                        <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
                        <Route path="/case-studies" element={<Layout><CaseStudiesPage /></Layout>} />
                        <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
                        <Route path="/blog/:slug" element={<Layout><BlogPostPage /></Layout>} />
                        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
                        
                        {/* Service & Industry Landing Pages (dynamic) */}
                        <Route path="/gmb-optimization-services" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/geo-seo-services" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/ai-search-optimization" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/seo-services" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/programmatic-seo" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/healthcare-seo" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/clinic-seo" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/travel-seo" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/visa-agency-seo" element={<Layout><DynamicPage /></Layout>} />
                        <Route path="/local-business-seo" element={<Layout><DynamicPage /></Layout>} />
                        
                        {/* Catch-all 404 */}
                        <Route path="*" element={<Layout><DynamicPage /></Layout>} />
                    </Routes>
                    <Toaster 
                        position="top-right"
                        toastOptions={{
                            className: 'font-sans',
                        }}
                    />
                </CMSProvider>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
